export default "__VITE_ASSET__DsVJTPPg__"